import React, { useEffect, useState } from 'react';
import 'rc-slider/assets/index.css';
import TagList from './common/TagList.client';

export default function Category({}) {
  return (
    <>
      <TagList title={"Categoría"} apiSection={"category"}></TagList>
    </>
  );
}
